import { DocumentType, ShipmentCreate, useApiLogisticsShipmentsCreate } from 'api';

import { useUploadAndCreateShipmentDocument } from './useUploadAndCreateShipmentDocument';

export const useCreateShipment = () => {
  const uploadAndCreateDocument = useUploadAndCreateShipmentDocument();
  const { mutateAsync: create, ...rest } = useApiLogisticsShipmentsCreate();

  const createShipment = async (bookingConfirmation: File | null = null, data: ShipmentCreate) => {
    const shipment = await create({ data });
    if (bookingConfirmation) {
      await uploadAndCreateDocument(
        {
          file: bookingConfirmation,
          type: DocumentType.BC,
        },
        { name: shipment.name }
      );
    }
    return shipment;
  };

  return {
    createShipment,
    ...rest,
  };
};
